import type { ReactNode } from 'react';

import { cn } from '@eliadmin/core/src/utils/style-utils';

/** One slide of `Carousel` (kept outside the client module so sections render it on the server). */
export function CarouselItem({ children, className }: { children: ReactNode; className?: string }) {
  return <li className={cn('flex shrink-0 snap-start', className)}>{children}</li>;
}
